export function isAuthFailureWebSocketCloseCode(code) {
  return code === 4001 || code === 4003;
}
